// Pure geometry for the before/after underline sweep (see feature_showcase_controller).
// Given the card corner and the measured line/clip widths (px), returns the start/end
// translateX so the line travels fully off one frame edge to the other, matching the
// iris direction: right-corner cards (tr/br) open the iris — and so sweep — right→left;
// left corners (tl/bl) go left→right. Offsets are derived from the measured widths so
// they stay correct if the CSS line width changes.
export const underlineSweepBounds = (corner, lineWidth, clipWidth, margin = 24) => {
  const fromRight = corner === 'tr' || corner === 'br';
  const offLeft = -(lineWidth + margin); // fully past the left edge
  const offRight = clipWidth + margin; // fully past the right edge
  return fromRight ? { startX: offRight, endX: offLeft } : { startX: offLeft, endX: offRight };
};
